import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { exigirAcceso } from '@/entities/usuario';
import { ProyectoDetailPage } from '@/pages/proyecto-detail';

const TAB_SCHEMA = z
  .enum(['resumen', 'fases', 'incidencias', 'seguimiento', 'ampliaciones', 'equipo'])
  .optional();

/**
 * Search params del detalle:
 *  - `tab` sincroniza la pestaña activa: /proyectos/42?tab=seguimiento
 *  - `incidencia` deep-linkea el detalle de una incidencia concreta dentro
 *    de la tab Incidencias: /proyectos/42?tab=incidencias&incidencia=48
 *    (lo usa, p. ej., el panel de notificaciones).
 *
 * Mantenerlos en la URL deja que la recarga preserve el contexto y que
 * enlaces directos abran en la sección correcta.
 */
const searchSchema = z.object({
  tab: TAB_SCHEMA,
  incidencia: z.coerce.number().int().positive().optional(),
});

export const Route = createFileRoute('/_private/proyectos/$id/')({
  validateSearch: searchSchema,
  beforeLoad: () => exigirAcceso('proyectos'),
  component: ProyectoDetailPage,
});
